export default function (params) {
  const form = new FormData();
  Object.entries(params).forEach(([field, value]) => {
    form.append(field, value);
  });

  return form;
}
